import { Component } from '@angular/core';
import { SubjectManageService } from '@g99-product-web-ui/shared-service';

@Component({
  selector: 'g99-auth-additional-option-footer',
  templateUrl: './auth-additional-option-footer.component.html',
  styleUrl: './auth-additional-option-footer.component.scss',
  standalone: false,
})
export class AuthAdditionalOptionFooterComponent {
  constructor(private readonly _subjectManagerService: SubjectManageService) {}

  /**
   * Logs the user out by clearing local storage and redirects to the login page.
   */
  protected logoutAndLogin(): void {
    this._subjectManagerService.logout();
  }
}
